import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/cal-ay/apps/web/app/(use-page-wrapper)/(main-nav)/availability/skeleton.tsx");
